import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { FontIcon } from 'react-md';

const Group = ({ title, show, index, setShowGroup, children }) => (
  <div className="group" style={{ marginTop: index !== 0 && !title ? '50px' : '0px' }}>
    {title && (
      <div className="head">
        <FontIcon className={cn({ show, hide: !show })}>change_history</FontIcon>
        <span className="title" role="presentation" onClick={setShowGroup}>
          {title}
        </span>
      </div>
    )}
    <div style={{ display: !show ? 'none' : undefined }} className="grid">
      {children}
    </div>
  </div>
);
Group.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  title: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  setShowGroup: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
};
Group.defaultProps = {};

export default Group;
